import { createFileRoute } from '@tanstack/react-router'
import ColecoesListPage from '@/pages/colecoes/colecoes-list'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/colecoes/',
)({
  component: function ColecoesIndexRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.CAMPANHAS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <ColecoesListPage dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
